export type Value = { _id: string; name: string; description?: string } | null;

export const parseSearchProfileFields = (fields: string) => {
  return JSON.parse(fields);
};
